import { render, staticRenderFns } from "./pageForm.vue?vue&type=template&id=600b182a&scoped=true&lang=html&"
import script from "./pageForm.vue?vue&type=script&lang=js&"
export * from "./pageForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600b182a",
  null
  
)

export default component.exports